import TemplateView from '../../../../../../TemplateView'
import $ from 'jquery'
import {getShortDayNameKey} from '../../../../utils'

export default class ImportHolidaysListLine extends TemplateView {
    constructor({
        name = '',
        date = new Date(),
    }) {
        super()

        this.params = {
            date,
            name,
        }
    }

    templateHtml() {
        return "<div class='holidayInfo'>" +
               "    <div class='dateColumn'> " +
               "        <span class='date'><%=date%></span>" +
               "        <span class='weekDay'><%=weekDay%></span>" +
               "    </div>" +
               "    <div class='nameColumn'><%-name%></div>" +
               "</div>"
    }

    templateModel() {
        return {
            date: $.datepicker.formatDate('M d', this.params.date),
            name: this.params.name,
        }
    }

    messageKeys() {
        return {
            weekDay: getShortDayNameKey(this.params.date.getDay()),
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/components/ImportHolidaysListLine.js